import React from "react";

class NotFound extends React.Component {
	render() {
		return (
			<div className="notfound">
				<p>The page you are looking for is not found</p>
			</div>
		);
	}
}

export default NotFound;